import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class NumberService {

  constructor() { }

  parseFloatComma(value: string): number {
    return parseFloat(value.replace(/,/g, '.'));
  }
}
